/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Start_LabelInputs */

const en_spellcheck_start_label = /** @type {(inputs: Spellcheck_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start spell check`)
};

const fr_spellcheck_start_label = /** @type {(inputs: Spellcheck_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrer la verification`)
};

const de_spellcheck_start_label = /** @type {(inputs: Spellcheck_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtschreibprüfung starten`)
};

const it_spellcheck_start_label = /** @type {(inputs: Spellcheck_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvia il controllo ortografico`)
};

const ru_spellcheck_start_label = /** @type {(inputs: Spellcheck_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать проверку орфографии`)
};

const es_spellcheck_start_label = /** @type {(inputs: Spellcheck_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar la revisión ortográfica`)
};

const zh_cn2_spellcheck_start_label = /** @type {(inputs: Spellcheck_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始拼写检查`)
};

const ja_spellcheck_start_label = /** @type {(inputs: Spellcheck_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペルチェックを開始`)
};

const hi_spellcheck_start_label = /** @type {(inputs: Spellcheck_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तनी जाँच शुरू करें`)
};

const pt_pt2_spellcheck_start_label = /** @type {(inputs: Spellcheck_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar verificação ortográfica`)
};

/**
* | output |
* | --- |
* | "Start spell check" |
*
* @param {Spellcheck_Start_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_start_label = /** @type {((inputs?: Spellcheck_Start_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Start_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_start_label(inputs)
	if (locale === "de") return de_spellcheck_start_label(inputs)
	if (locale === "it") return it_spellcheck_start_label(inputs)
	if (locale === "ru") return ru_spellcheck_start_label(inputs)
	if (locale === "es") return es_spellcheck_start_label(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_start_label(inputs)
	if (locale === "ja") return ja_spellcheck_start_label(inputs)
	if (locale === "hi") return hi_spellcheck_start_label(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_start_label(inputs)
	return en_spellcheck_start_label(inputs)
});